import { FC } from 'react';
import { ArrowDown } from '@doda/io-react/common';
import styles from './index.module.scss';
import { NaviItem } from '../../constants';

/**
 * NavigationListItem コンポーネントのプロパティ
 */
interface Props {
  /** ナビゲーションアイテム */
  item: NaviItem;
  /** 表示するタイトル */
  title: string;
  /** メニューの内容数 */
  menuContents: number | null;
  /** メニューを開いているかどうかの状態 */
  isOpenMenu: boolean;
  /** メニューを開くためのクリックハンドラー */
  onClickMenuOpen: (item: NaviItem) => void;
}

/**
 * NavigationListItem コンポーネント
 * @param {Props} props - NavigationListItem コンポーネントのプロパティ
 * @returns {JSX.Element} レンダリングされたコンポーネント
 */
export const NavigationListItem: FC<Props> = ({
  item,
  title,
  menuContents,
  isOpenMenu,
  onClickMenuOpen,
}) => {
  return (
    <li className={styles.followSearchResultsNavigation__item}>
      <button
        type="button"
        className={
          isOpenMenu && menuContents === item.id ? styles.is_active : ''
        }
        onClick={() => onClickMenuOpen(item)}
      >
        {title}
        <ArrowDown size="S" color="blue" />
      </button>
    </li>
  );
};
